import { Form } from "antd";
import styled from "styled-components";

export const RoleForm = styled(Form)`
  h3,
  h4,
  .ant-row {
    padding-bottom: 0px;
  }

  .ant-switch-checked {
    background: #5bd700;
    .ant-switch-inner {
      color: black;
    }
  }

  .ant-form-item {
    margin-bottom: 12px;
  }
`;
